/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable security/detect-object-injection */

import * as React from 'react';
import { ISplashPageViewProps } from './splash-page';

export default (props: ISplashPageViewProps) => {
    const { countryMappingJson } = props;

    if (Object.keys(countryMappingJson).length !== 0) {
        const [selectedKey, setSelectedKey] = React.useState<string>(Object.keys(countryMappingJson)[0]);

        const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            setSelectedKey(e.target.value);
        };

        const selectedData = countryMappingJson[selectedKey];

        return (
            <div className='splash-page-container'>
                <h1 className='splash-page-container--title'>{props.config.splashPageTitle}</h1>
                <div className='splash-page-container--info'>{props.config.splashPageInfoNote}</div>

                <div className='currency-container'>
                    {Object.keys(countryMappingJson).map(currency => (
                        <label key={currency} className='currency-item'>
                            <input
                                type='radio'
                                name='mainKey'
                                value={currency}
                                checked={selectedKey === currency}
                                onChange={handleRadioChange}
                            />
                            {currency}
                        </label>
                    ))}
                </div>

                <div>
                    {Object.keys(selectedData).map(geoArea => (
                        <div key={geoArea} className='geo-area-container'>
                            <div>
                                {Object.keys(selectedData[geoArea]).map(locale => {
                                    const path = selectedData[geoArea][locale].path || '';
                                    const href = `${path}${selectedKey}/${locale}`;
                                    return (
                                        <a key={locale} href={href} className='geo-area-item'>
                                            {geoArea}
                                        </a>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    } else {
        return <div>Ops! the module is not correctly configured</div>;
    }
};
